import {
  ADVISER_CATCH_UP_POINTS_OF_CONTACT,
  PRIMARY_ADVISER_CATCH_UP_POINT_OF_CONTACT,
} from "../../../../constants/adviserCatchUp";

const PRIMARY_MARKER_PATTERN = /(\*|:primary|\(primary\)|:default|\(default\))$/i;

const normaliseEmail = (value = "") =>
  String(value || "")
    .replace(PRIMARY_MARKER_PATTERN, "")
    .trim()
    .toLowerCase();

export const formatAdviserCatchUpPersonName = (email = "") => {
  const localPart = normaliseEmail(email).split("@")[0];
  if (!localPart) return "";

  return localPart
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const parseConfiguredPeople = (people = []) =>
  (Array.isArray(people) ? people : [])
    .map((entry) => {
      const raw =
        typeof entry === "string" ? entry.trim() : String(entry?.email || "").trim();
      return {
        email: normaliseEmail(raw),
        isPrimary:
          Boolean(entry?.isPrimary || entry?.isDefault) ||
          PRIMARY_MARKER_PATTERN.test(raw),
      };
    })
    .filter((person) => person.email);

const getConfiguredPeople = () =>
  parseConfiguredPeople(ADVISER_CATCH_UP_POINTS_OF_CONTACT);

export const getAdviserCatchUpOptions = () => {
  const emails = getConfiguredPeople().map((person) => person.email);

  return Array.from(new Set(emails));
};

export const getAdviserCatchUpSelectOptions = () =>
  getAdviserCatchUpOptions().map((email) => ({
    label: formatAdviserCatchUpPersonName(email),
    value: email,
  }));

export const isConfiguredAdviserCatchUpUser = (email = "") =>
  getAdviserCatchUpOptions().includes(normaliseEmail(email));

export const getPrimaryAdviserCatchUpEmail = () => {
  const configuredPeople = getConfiguredPeople();
  const options = getAdviserCatchUpOptions();
  const inlinePrimary = configuredPeople.find((person) => person.isPrimary);
  const configuredPrimary = normaliseEmail(
    PRIMARY_ADVISER_CATCH_UP_POINT_OF_CONTACT,
  );

  if (configuredPrimary && options.includes(configuredPrimary)) {
    return configuredPrimary;
  }

  if (inlinePrimary?.email && options.includes(inlinePrimary.email)) {
    return inlinePrimary.email;
  }

  return options[0] || "";
};

export const resolveAdviserCatchUpPrimaryEmail = (
  catchUpData = {},
  adviserDoc = {},
) => {
  const assignedEmail = String(
    catchUpData?.primaryPointOfContact?.email ||
      catchUpData?.primaryContact?.email ||
      adviserDoc?.defaultSupportStaff?.email ||
      adviserDoc?.responsiblePerson?.email ||
      adviserDoc?.responsiblePersonEmail ||
      "",
  )
    .trim()
    .toLowerCase();

  return assignedEmail;
};

export const resolveAssignedStaffEmails = (catchUpData = {}, adviserDoc = {}) => {
  let assigned = [];

  if (Array.isArray(catchUpData?.assignedStaff)) {
    assigned = catchUpData.assignedStaff;
  } else if (Array.isArray(catchUpData?.assignedSupportStaff)) {
    assigned = catchUpData.assignedSupportStaff;
  } else if (Array.isArray(adviserDoc?.assignedSupportStaff)) {
    assigned = adviserDoc.assignedSupportStaff;
  }

  const assignedEmails = assigned
    .map((person) =>
      typeof person === "string" ? person : person?.email,
    )
    .map(normaliseEmail)
    .filter(Boolean);

  const legacyEmail = normaliseEmail(
    adviserDoc?.responsiblePerson?.email ||
      adviserDoc?.responsiblePersonEmail ||
      "",
  );

  return Array.from(new Set([...assignedEmails, legacyEmail].filter(Boolean)));
};
